export default __webpack_public_path__ + "static/media/11.31167936.png";